import { useEffect, useState } from 'react';
import { Box, Button, Typography, TextField, Grid2 } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ToastContainer, toast } from 'react-toastify';
import {
	getAllcoupon,
	createCoupon,
	updateCoupon,
	deleteCoupon,
	toggleCouponStatus,
} from '../../../../services/api/Coupon';
import CouponTable from '../CouponTable';
import CouponFormDialog from '../couponFrom/CouponFormDialog';
import ConfirmDeleteDialog from '../ConfirmDeleteDialog';

export default function CouponView() {
	const [coupons, setCoupons] = useState([]);
	const [search, setSearch] = useState('');
	const [filteredCoupons, setFilteredCoupons] = useState([]);
	const [openForm, setOpenForm] = useState(false);
	const [editingData, setEditingData] = useState<any>(null);
	const [openDelete, setOpenDelete] = useState(false);
	const [deleteId, setDeleteId] = useState('');
	const [couponSubmit, setCouponSubmit] = useState(false);

	const fetchData = async () => {
		const res = await getAllcoupon();
		if (res.success) {
			setCoupons(res.data);
			setFilteredCoupons(res.data);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		const filtered = coupons.filter((item: any) =>
			item.code.toLowerCase().includes(search.toLowerCase())
		);
		setFilteredCoupons(filtered);
	}, [search, coupons]);

	const handleEdit = (data: any) => {
		setEditingData(data);
		setOpenForm(true);
	};

	const handleCreate = () => {
		setEditingData(null);
		setOpenForm(true);
	};

	const handleFormSubmit = async (data: any) => {
		if (editingData?._id) {
			const res = await updateCoupon(editingData._id, data);
			if (res.success) {
				fetchData();
				toast.success('Coupon updated successfully');
			} else {
				const msg = res?.data?.errors || 'Failed to update coupon';
				toast.error(msg);
			}
		} else {
			const res = await createCoupon(data);
			if (res.success) {
				fetchData();
				setCouponSubmit(true);
				toast.success('Coupon created successfully');
			} else {
				const msg = res?.data?.errors || 'Failed to create coupon';
				toast.error(msg);
			}
		}
		setOpenForm(false);
	};

	const handleDelete = async () => {
		const res = await deleteCoupon(deleteId);
		if (res.success) {
			fetchData();
			toast.info(res?.data?.message);
		} else {
			toast.error(res?.data?.message);
		}
		setOpenDelete(false);
	};

	const handleToggleStatus = async (id: string, currentStatus: number) => {
		const payload = { status: currentStatus === 1 ? 0 : 1 };
		const res = await toggleCouponStatus(id, payload);
		if (res.success) {
			fetchData();
			toast.success('Coupon status updated');
		} else {
			toast.error('Failed to update status');
		}
	};

	return (
		<Box p={3}>
			<Typography variant="h5" mb={2} sx={{ fontSize: { xs: 17, md: 20 } }}>
				Coupon Management
			</Typography>

			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, md: 6 }}>
					<TextField
						placeholder="Search by Code"
						variant="outlined"
						size="small"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						InputProps={{
							startAdornment: <SearchIcon sx={{ mr: 1 }} />,
						}}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, md: 6 }}>
					<Box sx={{ display: 'flex', justifyContent: 'end' }}>
						<Button variant="contained" onClick={handleCreate}>
							Add Coupon
						</Button>
					</Box>
				</Grid2>
			</Grid2>
			<Box sx={{ mt: 2 }}>
				<CouponTable
					data={filteredCoupons}
					onEdit={handleEdit}
					onDelete={(id: any) => {
						setDeleteId(id);
						setOpenDelete(true);
					}}
					onToggleStatus={handleToggleStatus}
				/>
			</Box>

			<CouponFormDialog
				open={openForm}
				onClose={() => setOpenForm(false)}
				onSubmit={handleFormSubmit}
				initialData={editingData}
				couponSubmit={couponSubmit}
			/>

			<ConfirmDeleteDialog
				open={openDelete}
				onClose={() => setOpenDelete(false)}
				onConfirm={handleDelete}
			/>

			{/* ✅ Toast container must be at root level of component */}
			<ToastContainer position="top-right" autoClose={3000} hideProgressBar />
		</Box>
	);
}
